const is_mobile = device.mobile;

let styles = {
    container: {
        background: 'white',
        padding: '2%',
        display: 'flex',
        justifyContent: 'center',
    },
    main_header: {
        padding:'0px',
        margin:'10px 0px',
        display:'flex',
        background: '#7d3cff',
    },
    title: {
        padding:'5px',
        textAlign:'center',
        borderRadius:'0px'
    },
    row: {
        margin:'1% 0%',
        fontSize:'15px',
        fontWeight:'600'
    },
    table_header: {
        marginTop:'1%',
        padding:10,
        display:"flex",
        fontWeight:'600',
        color:'black'
    },
    table: {
        marginTop:'0%',
        marginBottom:'2%'
    },
    header: {
        marginBottom:'0%',
        marginTop:'1%'
    },
    date: {
        display: 'flex',
        padding: 0,
        marginBottom:'2%',
    },
    breakUpContainer:{
        display: 'grid',
        gridTemplateColumns:is_mobile() ? 'repeat(auto-fill, minmax(150px, 1fr))' : 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: '15px'
    },
    statContainer:{
        padding: '15px',
        backgroundColor: '#f8f9fa',
        borderRadius: '4px',
        border: '1px solid #e9ecef'
    },
    statLabel:{
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#495057',
        marginBottom: '8px'
    },
    statValue:{
        fontSize: '18px',
        color: '#28a745'
    },
    am_sport_container: {
        display: 'flex',
        overflowX: 'auto',
        padding: '10px',
        gap: '10px',
        scrollbarWidth: 'thin',
        background: '#f9f9f9',
        borderRadius: '22px',
        border: '1px solid #E1EBFF',
        marginBottom: '1%',
    },
    am_sport_card: {
        borderRadius: '12px',
        padding: '24px',
        backgroundColor: '#f0f5fa',
        border: '1px solid #E1EBFF',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        width: '300px',
        transition: 'transform 0.25s ease',
    },
    card_title: {
        fontSize: '18px',
        fontWeight: '600',
        marginBottom: '10px',
        color: '#333',
    },
    card_value: {
        fontSize: '16px',
        color: '#2e7d32',
    },
  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/RevenueDetails/style.js